import lang from '../../lib/language';
import { getLimitedText } from '../../lib/util/DataHelpers';

export const WATCH_LIST_TABLE_HEADERS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonChart(),
  lang.commonLastPriceShort(),
  lang.commonChange(),
  lang.commonPercentChange(),
];

export const WATCH_LIST_TABLE_ITEMS = [
  'date',
  'priceRange',
  'industry',
  'time',
  'status',
  'ratio',
  'eventType',
  'ordType',
  'orderQty',
  'price',
  'orderValue',
  'purchasePrice',
  'investments',
  'marketValue',
  'valueShare',
  'type',
  'marketPrice',
  'unrealizedProfit',
  'createdAt',
  'updatedAt',
  'buttons',
  'quantity',
  'type',
  'setPrice',
  'expiryDate',
  'datePlaced',
];
export const TABLE_HEADERS_EARNINGS_CALENDARS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonDate(),
  lang.headerEarningsCalendarEarningsCallTime(),
  lang.headerEarningsCalendarEarningsPrevEPS(),
  lang.headerEarningsCalendarEarningsEPSEstimate(),
];
export const TABLE_HEADERS_MY_ACCOUNT_MY_STOCKS = [
  lang.commonSymbol(),
  lang.headerMyAccountMyStockQuantity(),
  lang.headerMyAccountMyStockPurchasePrice(),
  lang.headerMyAccountMyStockMarketPrice(),
  lang.headerMyAccountMyStockUnrealizedProfit(),
  lang.headerMyAccountMyStockButtons(),
];

export const TABLE_HEADERS_SYMBOL_DETAILS_PENDING_ORDERS = [
  lang.headerMyAccountPendingOrderDatePlaced(),
  lang.headerMyAccountPendingOrderType(),
  lang.headerMyAccountPendingOrderQuantity(),
  lang.headerMyAccountPendingOrderSetPrice(),
  lang.headerMyAccountPendingOrderExpiryDate(),
  lang.headerMyAccountPendingOrderButtons(),
];

export const WATCH_LIST_TABLE_HEADERS_MY_ACCOUNT_PENDING_ORDERS = [
  lang.headerMyAccountPendingOrderSymbolName(),
  ...TABLE_HEADERS_SYMBOL_DETAILS_PENDING_ORDERS,
];

export const getColumnCountFromGrid = (gridTemplateColumns?: string): number => {
  if (gridTemplateColumns === 'FOUR_ROW_ITEMS_GRID') {
    return 4;
  }
  return 5;
};

export const getLimitedTextByBrowserWidth = (
  browserWidthSize: number,
  name: string,
  isWithNews: boolean,
  columnCount: number = 5,
) => {
  let columnMultiplier = 1;

  if (columnCount === 4) {
    columnMultiplier = 1.25;
  } else if (columnCount === 3) {
    columnMultiplier = 1.5;
  }

  const baseBreakpoints = [
    { width: 1580, chars: 60 },
    { width: 1550, chars: isWithNews ? 30 : 60 },
    { width: 1520, chars: isWithNews ? 26 : 60 },
    { width: 1500, chars: isWithNews ? 25 : 60 },
    { width: 1450, chars: isWithNews ? 20 : 60 },
    { width: 1350, chars: isWithNews ? 22 : 60 },
    { width: 1310, chars: isWithNews ? 25 : 60 },
    { width: 1280, chars: isWithNews ? 25 : 60 },
    { width: 1024, chars: 40 },
    { width: 950, chars: 30 },
    { width: 900, chars: 25 },
    { width: 850, chars: 13 },
    { width: 800, chars: 10 },
    { width: 769, chars: isWithNews ? 2 : 6 },
    { width: 750, chars: 55 },
    { width: 700, chars: 40 },
    { width: 600, chars: 35 },
    { width: 520, chars: 20 },
    { width: 420, chars: 15 },
    { width: 390, chars: 10 },
    { width: 375, chars: 8 },
    { width: 360, chars: 10 },
    { width: 0, chars: 5 },
  ];

  const breakpoints = baseBreakpoints.map((bp) => ({
    width: bp.width,
    chars: Math.round(bp.chars * columnMultiplier),
  }));

  if (browserWidthSize >= breakpoints[0].width) {
    return getLimitedText(name, breakpoints[0].chars);
  }

  for (let i = 0; i < breakpoints.length - 1; i += 1) {
    const upper = breakpoints[i];
    const lower = breakpoints[i + 1];

    if (browserWidthSize >= lower.width) {
      const widthRange = upper.width - lower.width;
      const charRange = upper.chars - lower.chars;
      const widthDiff = browserWidthSize - lower.width;
      const proportion = widthDiff / widthRange;
      const charLimit = Math.round(lower.chars + charRange * proportion);

      return getLimitedText(name, Math.max(lower.chars, Math.min(upper.chars, charLimit)));
    }
  }

  // Below all breakpoints, use the minimum
  return getLimitedText(name, breakpoints.at(-1)!.chars);
};
